import { render, staticRenderFns } from "./JobsProvider.vue?vue&type=template&id=3083857b&scoped=true&"
import script from "./JobsProvider.vue?vue&type=script&lang=js&"
export * from "./JobsProvider.vue?vue&type=script&lang=js&"
import style0 from "./JobsProvider.vue?vue&type=style&index=0&id=3083857b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083857b",
  null
  
)

export default component.exports